export const integrations = {
	integrations: "Integrações",
	integrationsDescription:
		"Acesse dados da operação via API da Zig: loja, vendas, fiscais, bônus, recargas e mais.",
	createDrawer: {
		addPlaces: "Vincular locais",
		addPlacesDescription: "Selecione os locais que deseja vincular este token.",
		selectPlaces: "Selecione os locais",
		selectAll: "Selecionar todos",
		generateTokenMessage:
			"Este token será gerado e vinculado aos locais selecionados ({{count}}). Ele só poderá ser usado para autenticar integrações com a API Zig nesses locais. Deseja continuar?",
		generateTokenMessageAllPlaces:
			"Este token será gerado e vinculado a todos os locais selecionados (atuais e futuros). Ele só poderá ser usado para autenticar integrações com a API Zig nesses locais. Deseja continuar?",
		generateTokenConfirm: "Gerar token e vincular aos locais",
		cancelTokenMessage:
			"Ao cancelar, o token não será criado e a seleção dos locais será descartada. Deseja continuar assim mesmo?",
		cancelToken: "Cancelar token",
		linkToAllPlaces: "Vincular a todos os locais",
		allPlacesPlaceholder: "Todos os locais selecionados (atuais e futuros)",
	},
	token: "Token",
	createToken: "Gerar Token",
	techDocumentation: "Documentação técnica",
	searchPlaceholder: "Buscar pelo ID do local",
	noContentTitle: "Ainda não tem nada por aqui",
	noContentDescription:
		"Gere um token para integrar sistemas externos com a API Zig. Copie e use na autenticação.",
	noDataTitle: "Não encontramos o que você procura",
	noDataDescription: "O local não foi encontrado.",
	generatedBy: "Gerado por | ",
	generatedByDate: " em ",
	generatedByTime: " às ",
	viewLinkedPlaces: "Ver locais vinculados",
	linkedPlaces: "Locais vinculados",
	copyToken: "Copiar token",
	copyTokenButtonSuccess: "Copiado",
	copyTokenTooltip: "Copiar token completo para autenticação via API",
	copyTokenSuccess: "O código do token foi copiado para área de transferência",
	deleteToken: "Deletar token",
	deleteTokenConfirm: "Deletar token",
	deleteTokenConfirmMessage:
		"Ao deletar este token, poderá afetar integrações em andamento de todos os locais vinculados a ele. Deseja continuar assim mesmo?",
	successCreateToken: "Token criado com sucesso",
	successDeleteToken: "Token deletado com sucesso",
	alertTitle:
		"O token concede acesso total à API da Zig. Utilize apenas em integrações seguras.",
	alertDescription: "Uma vez criado, ele permanecerá ativo até ser excluído.",
	tokenListTitle: "API Token",
	orgInfo: "Rede | ",
	allPlacesToken: "Todos os locais",
};
